import Vue from "vue";

export const ChatRefressEventBus = new Vue();
